import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { defaultLanguage, getLocale, languageOptions } from "./index";

const LanguageContext = createContext({
  language: defaultLanguage,
  locale: getLocale(defaultLanguage),
  setLanguage: () => {},
  languageOptions,
});

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    if (typeof window === "undefined") return defaultLanguage;
    return window.localStorage.getItem("myqrmenu-language") || defaultLanguage;
  });

  const locale = useMemo(() => getLocale(language), [language]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("myqrmenu-language", language);
    }
  }, [language]);

  return (
    <LanguageContext.Provider
      value={{ language, locale, setLanguage, languageOptions }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
